<template>
  <div class="page">
    <div class="title">
      <span>{{$route.query.deptName}}</span>
      <div class="right">
        <Button @click.native="handleClickReset" style="margin-right:20px">重置</Button>
        <Button @click.native="handleClickSearch" :loading="isLoading1" style="margin-right:20px">搜索</Button>
        <Button @click="showAdd = true" type="primary">新增管理员</Button>
      </div>
      <div class="left">
        <Icon
          @click="$router.push({name: 'Department'})"
          :size="34"
          style="cursor:pointer"
          color="#999999"
          type="ios-arrow-back"
        />
      </div>
    </div>
    <search :users="users" ref="search" />
    <list
      @onClickDel="onClickDel"
      @onPageChange="onPageChange"
      :isLoading="isLoading1"
      :data="data"
      :total="total"
      style="margin-top:20px"
    />
    <Modal @on-visible-change="onVisibleChange" :value="showAdd" title="新增管理员">
      <Form>
        <FormItem label="管理员姓名">
          <Select
            remote
            :remote-method="getUserList"
            :loading="isLoading2"
            filterable
            clearable
            placeholder=""
            v-model="formData.valIndex"
            @on-change="onSelectChange"
          >
            <Option
              v-for="(item, index) in users"
              :value="index"
              :key="item.unionId"
            >{{item.realName}}({{item.userName}})</Option>
          </Select>
        </FormItem>
        <FormItem label="手机号码">
          <Select
            remote
            :remote-method="getUserList1"
            :loading="isLoading2"
            filterable
            clearable
            placeholder=""
            v-model="formData.valIndex"
            @on-change="onSelectChange"
          >
            <Option
              v-for="(item, index) in users"
              :value="index"
              :key="item.unionId"
            >{{item.phoneNO}}</Option>
          </Select>
        </FormItem>
        <!-- <FormItem label="手机号码">
          <Input v-model="formData.phoneNO" :rows="10" />
        </FormItem> -->
      </Form>
      <section slot="footer">
        <Button @click.native="showAdd = false" style="margin-right:20px">取消</Button>
        <Button :loading="isLoading" @click="handleClickaddManager" type="primary">确定</Button>
      </section>
    </Modal>
  </div>
</template>

<script>
import Search from "./Search";
import List from "./List";
import api from "../../../api/index";
const { getManagerList, getUserList, addManager, delManager } = api;
export default {
  data() {
    return {
      showAdd: false,
      formData: {
        userName: "",
        phoneNO: "",
        unionId: "",
        valIndex: ""
      },
      pageNum: 1,
      pageSize: 10,
      total: 0,
      data: [],
      users: [],
      isLoading: false,
      isLoading1: false,
      isLoading2: false,
      searchForm: {}
    };
  },
  components: {
    Search,
    List
  },
  methods: {
    onSelectChange(val) {
      if (val === undefined) {
        this.clearFormData();
      } else {
        let { userName, phoneNO, unionId } = this.users[val];
        this.formData.userName = userName;
        this.formData.unionId = unionId;
        this.formData.phoneNO = phoneNO;
      }
    },
    clearFormData() {
      for (let key in this.formData) {
        this.formData[key] = "";
      }
    },
    handleClickSearch() {
      let searchForm = this.$refs.search.formData;
      this.searchForm = searchForm;

      this.getManagerList();
    },
    onClickDel(id) {
      this.delManager(id);
    },
    async delManager(id) {
      try {
        let res = await this.$delete(delManager, { idList: id });
        this.$Message.success("删除成功");
        this.getManagerList();
      } finally {
      }
    },
    onPageChange(page) {
      this.pageNum = page;
      this.getManagerList();
    },
    handleClickReset() {
      this.$refs.search.reset();
    },
    async getManagerList() {
      this.isLoading1 = true;

      try {
        let res = await this.$post(getManagerList, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchForm,
          deptId: Number(this.$route.query.id)
        });
        this.data = res.rows;
        this.total = res.total;
      } finally {
        this.isLoading1 = false;
      }
    },
	async getUserList1(val) {
	  if (val.trim() != "") {
	    this.isLoading2 = true;
	    try {
	      let res = await this.$post(getUserList, {
	        deptId: this.$route.query.id,
	        phoneNO: val
	      });
	      this.users = res.rows;
	    }finally{
	      this.isLoading2 = false
	    }
	  }else{
	    this.users = []
	  }
	},
    async getUserList(val) {
      if (val.trim() != "") {
        this.isLoading2 = true;
        try {
          let res = await this.$post(getUserList, {
            deptId: this.$route.query.id,
            realName: val
          });
          this.users = res.rows;
        }finally{
          this.isLoading2 = false
        }
      }else{
        this.users = []
      }
    },
    onVisibleChange(e) {
      if (!e) {
        this.showAdd = false;
        for (let key in this.formData) {
          this.formData[key] = "";
        }
      }
    },
    async handleClickaddManager() {
      try {
        this.isLoading = true;
        let res = await this.$post(addManager, {
          ...this.formData,
          deptId: this.$route.query.id
        });
        this.$Message.success("添加成功");
        this.showAdd = false;
        this.getManagerList();
      } finally {
        this.isLoading = false;
      }
    }
  },
  created() {
    this.getManagerList();
  }
};
</script>


<style  scoped lang="less">
.page {
  padding: 0 20px;
}
.title {
  text-align: center;
  height: 85px;
  line-height: 85px;
  font-size: 24px;
  font-weight: bold;
  position: relative;
  .right {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
  }
  .left {
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
  }
}
</style>
